export const API = `${process.env.REACT_APP_API_BASE_URL}/api`;
export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const AUTH_TOKEN = "trialytix_authToken";
export const BEARER ="Bearer";